import styled from 'styled-components';

export const StyledDataGridToolbar = styled('div')`
  padding: 8px 8px 8px 24px;
  text-align: left;
  background-color: var(--ion-color-neutral-contrast);
`;

export const StyledDataGridTitle = styled('p')`
  color: var(--allie-color-neutral-70);
  &&& {
    font-weight: 600;
    font-size: 21px;
  }
  font-family: var(--ion-font-family);
  line-height: 28px;
  margin: 0;
`;

export const StyledDataGridSection = styled('section')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
